// extracted by mini-css-extract-plugin
export default {"centeredParagraphs":"oncV7HDL-ovWntLOkAojNw==","subTitle":"AbA8fYTc9AAQuP9BeRD56A==","text":"_0QGsCcb5i2QaTeQ0BJPUTA==","buttonGroup":"I3SPc4tpzy3wx8lPhxo9Mg=="};